import type { SVGProps } from 'react';
const SvgIsoShield = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} fill="none" viewBox="0 0 20 21" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7 11 2 2 4-4m5.618-4.016A11.955 11.955 0 0 1 10 1.944a11.96 11.96 0 0 1-8.618 3.04A12 12 0 0 0 1 8c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016"
    />
  </svg>
);
export default SvgIsoShield;
